<template>
    <div class="bg-img h-screen flex w-full justify-center">
        <div class="text-center">
            <h3 class="text-primary mt-8 mx-4"><b>Cadastro Realizado!</b></h3>
            <h5 class="mt-6">{{ user.email }}</h5>
            <h4 class="mt-6 mx-4">Aguarde pela aprovação da empresa</h4>
            <Animation :animation="waitingAnimation" height="50vh" style="margin-top: -40px"/>
            
            <h5 class="mx-4">O responsável pela empresa <b>{{ company.description }}</b> deve aprovar sua solicitação de atendente.</h5>
            <a-spin size="large" class="mb-8 mt-12"/>
            <p>Você será redirecionado automaticamente</p>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import firebase from '@/firebase/firebase';
    import Animation from '../../../components/Animation.vue';
    import waitingAnimation from '@/assets/animations/approval-animation.json';

    export default {
        components: { Animation },
        props: {
            companyId: String
        },
        data() {
            return {
                // todo move this to store
                company: null,
                waitingAnimation,
                invites: []
            }
        },
        computed: {
            ...mapGetters({ 'user': 'getUserStoredData' })
        },
        methods: {
            welcomeUser () {
                this.$success({
                    zIndex: 9999999,
                    title: 'Convite aceito!',
                    content: `Agora você faz parte do time ${this.company.description}! Seja bem vindo(a)!`
                });
                this.$router.push('/companySelect/0');
            },
            informUser () {
                this.$error({
                    zIndex : 999999,
                    title: 'Convite recusado',
                    content: 'Lamentamos, mas o responsável pelo estabelecimento recusou o convite'
                });
                this.$store.dispatch('logout');
                this.$router.replace('/');
            },
            checkStatus (invite) {
                const { id, pending, approved } = invite;
                if (!this.invites.find(i => i.id == id)) {
                    alert('Problema na atualização do convite');
                    return;
                }
                if (!pending) {
                    if (approved)
                        this.welcomeUser();
                    else
                        this.informUser();
                }
            },
            async lookingForApproval () {
                const existing = await firebase.firestore().collection(`company/${this.companyId}/invites`)
                    .where('pending', '==', true)
                    .where('user.id', '==', this.user.id)
                    .get();
                if (!existing.size) {
                    this.$warning({
                        zIndex : 999999,
                        title: 'Sem convites',
                        content: 'Não foram encontrados convites para essa empresa. Deseja requisitar um?'
                    });
                }
                firebase.firestore().collection(`company/${this.companyId}/invites`)
                    .where('user.id', '==', this.user.id)
                    .onSnapshot(snapshot => {
                        snapshot.docChanges().forEach(change => {
                            const invite = { id: change.doc.id, ...change.doc.data() };
                            if(change.type === "added") {
                                if (invite.pending)
                                    this.invites.push(invite);
                            }
                            if(change.type === "modified")
                                this.checkStatus(invite);
                        })
                });
            }
        },
        async mounted () {
            const companySnap = await firebase.firestore().collection('company').doc(this.companyId).get();
            if (!companySnap.exists) {
                this.$error({
                    zIndex : 999999,
                    title: 'Empresa inválida',
                    content: `Não existe empresa com ID ${this.companyId}`,
                    onOk: () => { this.$router.back(); }
                });
                return;
            }
            this.company = companySnap.data();
            
            this.lookingForApproval();
        },
        beforeMount () {
            if (!this.companyId)
                this.$router.back();
        }
    }
</script>

<style lang="scss" scoped>

</style>